module.exports = __webpack_public_path__ + "img/1591806108.238bf4ea.jpg";